import React from 'react'
import PropsTypes from 'prop-types'
import classes from './styles.module.scss'

import { MaxiMazeIcon, MiniMazeIcon } from '../../icons/Icons'

const ResizeButton = ({ isLarge, onClick }) => (
  <div className={classes.wrapper} onClick={() => onClick(!isLarge)}>
    {isLarge ? <MiniMazeIcon /> : <MaxiMazeIcon />}
  </div>
)

ResizeButton.propTypes = {
  isLarge: PropsTypes.bool,
  onClick: PropsTypes.func,
  classes: PropsTypes.object,
}

export default ResizeButton
